/* eslint-disable no-console */
import {
  Box,
  Flex,
  VStack,
  Text,
  Icon,
  useColorMode,
  Badge,
} from '@chakra-ui/react';
import React from 'react';
import { Handle, NodeProps, Position } from 'reactflow';

import { DbTable } from '@finley-technologies/finley-types';

import { useNode } from '../hooks/bbplMonitorContext';
import { FiCheckCircle } from 'react-icons/fi';

// Function to determine the badge color based on the status
const statusColor = (status: DbTable.ArtifactInstance.Status | 'default') => {
  switch (status) {
    case 'success':
      return 'green';
    case 'error':
      return 'red';
    case 'inProgress':
      return 'yellow';
    case 'initializing':
      return 'blue';
    default:
      return 'gray';
  }
};

export const BBPLMonitorNodeDisplay: React.FC<NodeProps<string>> = ({
  data,
}) => {
  const { colorMode } = useColorMode();
  const node = useNode(data);
  const isDark = colorMode === 'dark';

  // Dynamic styles based on theme
  const bgColor = isDark ? 'gray.700' : 'white';
  const borderColor = isDark ? 'purple.300' : 'purple.500';
  const textColor = isDark ? 'white' : 'gray.800';

  if (!node) return null;

  return (
    <>
      {node.hasInputs && (
        <Handle
          type="target"
          position={Position.Left}
          style={{ width: 12, height: 12 }}
        />
      )}
      <Box
        onClick={() =>
          console.log('BBPLMonitorNodeDisplay: Node clicked', node)
        }
        bg={bgColor}
        border="2px solid"
        borderColor={borderColor}
        borderRadius="lg"
        p={4}
        maxW="300px"
        boxShadow={isDark ? 'lg' : 'base'}
      >
        <Flex alignItems="center">
          <Icon
            as={FiCheckCircle}
            boxSize="6"
            color={statusColor(
              node.instance ? node.instance.status : 'default',
            )}
          />
          <VStack align="stretch" ml={4}>
            <Text maxWidth="150px" isTruncated color={textColor}>
              {node.artifact.artifactSlug}
            </Text>
            <Badge
              variant="solid"
              colorScheme={statusColor(
                node.instance ? node.instance.status : 'default',
              )}
              p={1}
            >
              {node.instance ? node.instance.status : 'Pending'}
            </Badge>
          </VStack>
        </Flex>{' '}
      </Box>
      {node.hasOutputs && (
        <Handle
          type="source"
          position={Position.Right}
          style={{ width: 12, height: 12 }}
        />
      )}
    </>
  );
};
